import { getPublicBaseUrl, publicAbsoluteUrl } from '../publicBaseUrl';

/** Shared actionCodeSettings for all Firebase Auth transactional emails. */
export function getAuthActionCodeSettings(continuePath: string) {
  const path = continuePath.startsWith('/') ? continuePath : `/${continuePath}`;
  return {
    url: publicAbsoluteUrl(path),
    handleCodeInApp: false as const,
  };
}
